var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountManagementLockDarkGray2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9625 6.50151H13.1516V4.30464C13.1516 2.28589 11.5188 0.653076 9.50005 0.653076C7.4813 0.653076 5.87817 2.28589 5.87817 4.30464V6.50151H4.06724C2.93911 6.50151 2.0188 7.39214 2.0188 8.46089V12.7656C2.0188 15.8234 4.66099 18.3171 7.89692 18.3171H11.1625C14.3985 18.3171 17.011 15.7937 17.011 12.6765V8.46089C17.011 7.39214 16.0907 6.50151 14.9625 6.50151ZM7.21411 4.30464C7.21411 3.02808 8.25317 1.98901 9.52974 1.98901C10.8063 1.98901 11.8454 3.02808 11.8454 4.30464V6.50151H7.21411V4.30464ZM15.675 12.6765C15.675 15.0515 13.6563 16.9812 11.1625 16.9812H7.89692C5.40317 16.9812 3.35474 15.0812 3.35474 12.7656V8.46089C3.35474 8.10464 3.6813 7.83745 4.06724 7.83745H14.9625C15.3485 7.83745 15.675 8.10464 15.675 8.46089V12.6765Z",
    fill: "#111827"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7173 11.6968H8.28291C7.74853 11.6968 7.30322 12.1421 7.30322 12.6765V15.1108C7.30322 15.6452 7.74853 16.0905 8.28291 16.0905H10.7173C11.2517 16.0905 11.697 15.6452 11.697 15.1108V12.6765C11.697 12.1421 11.2517 11.6968 10.7173 11.6968ZM10.361 14.7249H8.66885V13.0327H10.361V14.7249Z",
    fill: "#111827"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountManagementLockDarkGray2);
export default __webpack_public_path__ + "static/media/account-management-lock-dark-gray-2.2dbbae983c1a0c2f125ed4eb689271b3.svg";
export { ForwardRef as ReactComponent };